import { LessonPlanRole, LessonPlanSessionModel } from '../../object-actions/types/types';

/** Athlete may mark sessions complete when there is no human coach. */
export function athleteMaySelfCompleteSessions(hasHumanCoach?: boolean): boolean {
    return !hasHumanCoach;
}

/** Who may track slide progress and mark sessions complete on a published plan. */
export function canManageSessionProgress(
    myRoles?: LessonPlanRole[],
    hasHumanCoach?: boolean,
): boolean {
    const isCoachOrParent = myRoles?.includes('coach') || myRoles?.includes('parent');
    const isAthleteSelfComplete =
        myRoles?.includes('athlete') && athleteMaySelfCompleteSessions(hasHumanCoach);
    return Boolean(isCoachOrParent || isAthleteSelfComplete);
}

/** Who may read and write private session notes. Mirrors user_is_coach_or_guardian on the API. */
export function canAccessSessionNotes(myRoles?: LessonPlanRole[]): boolean {
    return Boolean(myRoles?.includes('coach') || myRoles?.includes('parent'));
}

/** Session-level: has this session been started? (LessonPlanSession.started_at) */
export function hasSessionStarted(session: LessonPlanSessionModel): boolean {
    return !!session.started_at;
}

/** Slide-level: do all slides in this session have started_at? (SessionSlide.started_at) */
export function areAllSlidesTrackedForSession(session: LessonPlanSessionModel): boolean {
    if (!session.slides || session.slides.length === 0) return false;
    for (let i = 0; i < session.slides.length; i++) {
        if (!session.slides[i]?.started_at) return false;
    }
    return true;
}

/** Index of the first session that does not have all slides tracked. Sessions are assumed backend-ordered. */
export function getFirstIncompleteSessionIndex(sessions: LessonPlanSessionModel[]): number {
    const i = sessions.findIndex((s) => !areAllSlidesTrackedForSession(s));
    return i === -1 ? 0 : i;
}

/** Index of the first slide without started_at. Slides are assumed backend-ordered. 0 if all started or no slides. */
export function getFirstUnstartedSlideIndex(session: LessonPlanSessionModel): number {
    const slides = (session.slides || []).filter((s) => s != null);
    const i = slides.findIndex((s) => !s?.started_at);
    return i === -1 ? 0 : i;
}
